"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchQueryValidationDto = exports.DeleteShaftsDtoValidation = exports.EditShaftDtoValidation = exports.ShaftTypes = exports.RangeOptions = void 0;
const yup = require("yup");
const app_1 = require("./app");
var RangeOptions;
(function (RangeOptions) {
    RangeOptions["Low"] = "LOW";
    RangeOptions["LowMid"] = "LOW/MID";
    RangeOptions["Mid"] = "MID";
    RangeOptions["MidHigh"] = "MID/HIGH";
    RangeOptions["High"] = "HIGH";
})(RangeOptions = exports.RangeOptions || (exports.RangeOptions = {}));
var ShaftTypes;
(function (ShaftTypes) {
    ShaftTypes["BlankIron"] = "Blank Iron";
    ShaftTypes["DedicatedIron"] = "Dedicated Iron";
    ShaftTypes["Fairway"] = "Fairway";
    ShaftTypes["Hybrid"] = "Hybrid";
    ShaftTypes["WedgeOnly"] = "Wedge Only";
    ShaftTypes["Wood"] = "Wood";
    ShaftTypes["Putter"] = "Putter";
})(ShaftTypes = exports.ShaftTypes || (exports.ShaftTypes = {}));
exports.EditShaftDtoValidation = yup.object({
    id: yup.string().required(),
    type_int: yup.number().nullable(),
    shaft_id_export: yup.string().nullable(),
    date_updated: yup.date(),
    manufacturername: yup.string().required(),
    modelname: yup.string().required(),
    flexname: yup.string().nullable(),
    oem_aftermarket: yup.boolean().nullable(),
    release_date: yup.date().nullable(),
    terminal_date: yup.date().nullable(),
    length_in: yup.number().nullable(),
    butt_od_in: yup.number().nullable(),
    tip_od_in: yup.number().nullable(),
    parallel_length_in: yup.number().nullable(),
    mass_g: yup.number().nullable(),
    frequency_cpm_5in_clamp: yup.number().nullable(),
    torque_deg: yup.number().nullable(),
    balance_point_from_tip: yup.number().nullable(),
    butt_ei: yup.number().nullable(),
    mid_ei: yup.number().nullable(),
    tip_ei: yup.number().nullable(),
    deflection_profile_xin_yin: yup.string().nullable(),
    ei_profile_xin: yup.string().nullable(),
    s3_launch_deg: yup.number().nullable(),
    s3_launch_rel: yup
        .mixed()
        .oneOf([
        RangeOptions.High,
        RangeOptions.Low,
        RangeOptions.LowMid,
        RangeOptions.Mid,
        RangeOptions.MidHigh,
        null,
    ])
        .nullable(),
    manufacturer_sku: yup.string().nullable(),
    sku: yup.string().required(),
    min_build_fm: yup.number().nullable(),
    max_build_fm: yup.number().nullable(),
    total_adjustments: yup.number().nullable(),
    min_fitting_fm: yup.number().nullable(),
    max_fitting_fm: yup.number().nullable(),
    wedge_step: yup.number().nullable(),
    iscurrent: yup.boolean().nullable(),
    isgraphite: yup.boolean().nullable(),
    isparallel: yup.boolean().nullable(),
    type_string: yup
        .mixed()
        .oneOf([
        ShaftTypes.BlankIron,
        ShaftTypes.DedicatedIron,
        ShaftTypes.Fairway,
        ShaftTypes.Hybrid,
        ShaftTypes.Putter,
        ShaftTypes.WedgeOnly,
        ShaftTypes.Wood,
        null,
    ]),
    man_spin_test: yup
        .mixed()
        .oneOf([
        RangeOptions.High,
        RangeOptions.Low,
        RangeOptions.LowMid,
        RangeOptions.Mid,
        RangeOptions.MidHigh,
        null,
    ]),
    man_launch_test: yup
        .mixed()
        .oneOf([
        RangeOptions.High,
        RangeOptions.Low,
        RangeOptions.LowMid,
        RangeOptions.Mid,
        RangeOptions.MidHigh,
        null,
    ])
        .nullable(),
    basic_speed: yup.number().nullable(),
    max_tipping_in: yup.number().nullable(),
    cpmperintipping: yup.number().nullable(),
    price: yup.string().nullable(),
    deletedAt: yup.date().nullable(),
});
exports.DeleteShaftsDtoValidation = yup.object({
    ids: yup.array().of(yup.string()).min(1).required(),
});
exports.SearchQueryValidationDto = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    searchFilter: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
//# sourceMappingURL=shafts.js.map